"use client"
// import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Link from 'next/link';
import SocialMediaLinks from "../social/social";
import OneSignalInit from '@/app/funcs/OneSignal';
import GoogleAnalyticsScript from "@/app/funcs/tracking/googleAnalytics"
import ClarityScript from "@/app/funcs/tracking/clarity"
import android from './../../assets/images/google-download.webp'
import apple from './../../assets/images/apple-download.png'
import Image from 'next/image';
import PWAInstallButton from '../PWAInstallButton';
import { NewsletterSubscription } from '../newsletter/NewsletterSubscription';
import './footer.css';

export const Footer = () => {
    return (
        <footer id='footer' className="container">
            <div className="row col-12 col-md-6 justify-content-center justify-content-md-end mx-auto mb-5 pb-5  fade-in-up">
                <p className='d-block col-12'> حمّل تطبيق فيجماوية</p>
                <a className='col-12 col-md-6 mb-3 mb-md-0' href="https://apps.apple.com/app/figmawya/id6752803758" target="_blank" rel="noopener noreferrer"> <Image src={apple} alt="download iPhone" className='img-fluid mx-auto border p-3 rounded-4 filter-invert' /></a>
                <a className='col-12 col-md-6' href="https://play.google.com/store/apps/details?id=com.anonymous.figmawyamobileapp" target="_blank" rel="noopener noreferrer"> <Image src={android} alt="download android" className='img-fluid mx-auto border p-3 rounded-4 filter-invert' /></a>
                {/* <PWAInstallButton /> */}
            </div>


            {/* Newsletter Subscription Section */}
            <div className="col-12 col-md-10 col-lg-8 mx-auto mb-5">
                <NewsletterSubscription />
            </div>

            {/* Footer Navigation Section */}
            <div className="footer-navigation col-12 col-md-10 mx-auto">
                <div className="row">
                    {/* Column 1: About Figmawya */}
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="footer-nav-section ps-4 ps-md-5">
                            <h6 className="footer-nav-title">
                                <i className="bi bi-info-circle"></i>
                                عن فيجماوية
                            </h6>
                            <ul className="footer-nav-links">
                                <li>
                                    <Link href="/">
                                        <i className="bi bi-house"></i>
                                        الرئيسية
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/about">
                                        <i className="bi bi-info-circle"></i>
                                        عن فيجماوية
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/privacy-policy">
                                        <i className="bi bi-eye-slash"></i>
                                        سياسة الخصوصية
                                    </Link>
                                </li>


                                <li>
                                    <Link href="/sections/newsletter">
                                        <i className="bi bi-envelope-paper"></i>
                                        النشرة البريدية
                                    </Link>
                                </li>
                                <li>
                                    <Link href="" className="disabled">
                                        <i className="bi bi-question-circle"></i>
                                        الأسئلة الشائعة
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/contact">
                                        <i className="bi bi-envelope-arrow-up"></i>
                                        تواصل معنا
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Column 2: Active Services */}
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="footer-nav-section ps-4 ps-md-5">
                            <h6 className="footer-nav-title">
                                <i className="bi bi-wrench"></i>
                                الخدمات
                            </h6>
                            <ul className="footer-nav-links">

                                <li>
                                    <Link href="/calc">
                                        <i className="bi bi-calculator"></i>
                                        تسعير
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/figma-shortcuts">
                                        <i className="bi bi-keyboard"></i>
                                        اختصارات فيجما
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/lnk">
                                        <i className="bi bi-scissors"></i>
                                        إختصار الروابط
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/cert">
                                        <i className="bi bi-award"></i>
                                        الشهادات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="https://chatgpt.com/g/g-6827324583b48191a6713f1ec6b89bae-dhky-mn-fyjmwy-zaki-by-figmawya" target="_blank">
                                        <i className="bi bi-robot"></i>
                                        ذكي AI
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Column 3: Community & Learning */}
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="footer-nav-section ps-4 ps-md-5">
                            <h6 className="footer-nav-title">
                                <i className="bi bi-people"></i>
                                المجتمع والتعلم
                            </h6>
                            <ul className="footer-nav-links">
                                <li>
                                    <Link href="/sessions">
                                        <i className="bi bi-play-btn flip-v"></i>
                                        الجلسات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/podcasts">
                                        <i className="bi bi-mic"></i>
                                        حلقات البودكاست
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/articles">
                                        <i className="bi bi-pencil"></i>
                                        المقالات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/challenges">
                                        <i className="bi bi-trophy"></i>
                                        التحديات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/quizzes">
                                        <i className="bi bi-clipboard-check"></i>
                                        الاختبارات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/surveys">
                                        <i className="bi bi-ui-checks"></i>
                                        الاستبيانات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/ramadan">
                                        <i className="bi bi-moon"></i>
                                        رمضان 2026
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/courses">
                                        <i className="bi bi-mortarboard"></i>
                                        الدورات التعليمية
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/glossary">
                                        <i className="bi bi-book"></i>
                                        القاموس
                                    </Link>
                                </li>
                               

                            </ul>
                        </div>
                    </div>

                    {/* Column 4: Resources */}
                    <div className="col-6 col-md-6 col-lg-3">
                        <div className="footer-nav-section ps-4 ps-md-5">
                            <h6 className="footer-nav-title">
                                <i className="bi bi-box-seam"></i>
                                الموارد
                            </h6>
                            <ul className="footer-nav-links">
                                <li>
                                    <Link href="/sections/templates">
                                        <i className="bi bi-file-earmark-text"></i>
                                        قوالب
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/sections/plugins">
                                        <i className="bi bi-puzzle"></i>
                                        إضافات
                                    </Link>
                                </li>
                                <li>
                                    <Link href="/sections/jobs">
                                        <i className="bi bi-briefcase"></i>
                                        الوظائف
                                    </Link>
                                </li>

                                <li>
                                    <Link href="" className="disabled">
                                        <i className="bi bi-people-fill"></i>
                                        دليل المصممين
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>



            {/* Existing Footer Content */}
            {/* <iframe data-testid="embed-iframe" style={{ borderRadius: '12px' }} src="https://open.spotify.com/embed/episode/5KJypYbCnDDcma8EMRuYkS?utm_source=generator" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe> */}

            <SocialMediaLinks />
            <p className='text-muted  fade-in-up' style={{ fontSize: '0.8rem' }}> من القاهرة 🇪🇬 مروراً بالرياض 🇸🇦 إنطلاقاً إلى العالم 🌍 ❤️  {new Date().getFullYear()}  <br />
            </p>
            <span className="devBy text-muted fade-in-up" style={{ fontSize: '0.8rem' }}> الموقع نسخة تجريبية، تحملونا 🙏</span>
            {/* <span className="devBy"> تم التطوير بواسطة خبراء هندسة تجربة المستخدم UXEs، <a href="#">تعرف عليهم</a></span> */}


            <OneSignalInit />
            {/* <ClarityScript /> */}
            <GoogleAnalyticsScript />
        </footer>
    )
}


// export default Footer;
